import { BatchRequest } from '../..'
import { AppConfigurationKey } from '../../../../model/enums/appConfigurationKey'
import { getAppConfigurationValue } from '../../../../redux'
import AxiosInstance from '../../../http-config'

export const apiBatch = async (request: BatchRequest) => {
  const apiSuffixUrl = getAppConfigurationValue(AppConfigurationKey.PrefixEnviromentFrontServices)
  return await AxiosInstance.post(`${apiSuffixUrl}/oData/$Batch`, request).then(response => {
    return response.data
  })
}
